var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0 mt-3 mb-7 elevation-2",attrs:{"dense":"","color":"blue-grey lighten-5"}},[_c('v-layout',[_c('v-flex',_vm._l((_vm.menuItems),function(item,i){return _c('MenuItem',{key:i,staticClass:"mr-2",attrs:{"item":item}})}),1),_c('MenuItem',{staticClass:"justify-end text-right",attrs:{"item":{
        text: _vm.$t('global.tab.about'),
        to: '/app/about',
        icon: 'help_outline'
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }